window.addEventListener('DOMContentLoaded', () => {

  const mainMessage = document.querySelector('.annoucement-promo-main');
  const secondaryMessage = document.querySelector('.annoucement-promo-secondary');

  let showingMain = true;
  if(mainMessage && secondaryMessage){
    mainMessage.style.opacity = '1';
    mainMessage.style.display = 'flex';
    secondaryMessage.style.opacity = '0';
    secondaryMessage.style.display = 'none';
  }

  const style = document.createElement('style');
  style.textContent = `
  .announcement-bar__message_custom {
    transition: opacity 0.5s ease-in-out;
  }
`;
  document.head.appendChild(style);

  function alternateMessages() {
    if(mainMessage && secondaryMessage){
      if (showingMain) {
        mainMessage.style.opacity = '0';

        setTimeout(() => {
          mainMessage.style.display = 'none';
          secondaryMessage.style.display = 'flex';

          setTimeout(() => {
            secondaryMessage.style.opacity = '1';
          }, 10);
        }, 500);
      } else {
        secondaryMessage.style.opacity = '0';

        setTimeout(() => {
          secondaryMessage.style.display = 'none';
          mainMessage.style.display = 'flex';

          setTimeout(() => {
            mainMessage.style.opacity = '1';
          }, 10);
        }, 500);
      }

      showingMain = !showingMain;
    }
  }

  setInterval(alternateMessages, 6000);



});

 function copyCoupon(coupon){
    navigator.clipboard.writeText(coupon).then(function() {
      console.log('Coupon copied to clipboard:', coupon);
    }, function(err) {
      console.error('Could not copy text: ', err);
    });

    const copyButton = document.querySelector('.copy-button-annoucement-bar');
    copyButton.style.width ='100%';
    copyButton.style.height ='22px';
    copyButton.innerHTML = '<p>✅copiado!</p>';

    setTimeout(() => {
      copyButton.style.width ='48px';
      copyButton.style.position = 'initial';
      copyButton.innerText = 'copiar';
    },6000)
  }